module.exports = __webpack_public_path__ + "img/img6.ad814877.svg";